import { useEffect, useState } from "react";
import { Zap } from "lucide-react";

const DAY = 864e5;

const fmt = (ms) => {
  const m = Math.floor(Math.abs(ms) / 6e4);
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
};

export const RushCountdown = ({ o }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);

  const base = "font-mono-d inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs uppercase tracking-wider";
  if (!o.paid_at) return <span className={`${base} border border-[var(--amber)] text-[var(--amber)]`} data-testid={`admin-rush-${o.id}`}><Zap className="h-3 w-3" /> Rush 24h</span>;
  if (o.delivered) return <span className={`${base} border border-white/20 text-slate-300`} data-testid={`admin-rush-${o.id}`}><Zap className="h-3 w-3" /> Rush · delivered</span>;

  const left = new Date(o.paid_at).getTime() + DAY - now;
  const tone = left < 0 ? "bg-red-500 text-white animate-pulse" : left < 3 * 36e5 ? "bg-orange-500 text-[var(--ink)]" : "bg-[var(--amber)] text-[var(--ink)]";
  return (
    <span className={`${base} ${tone}`} data-testid={`admin-rush-${o.id}`} title={`Due ${new Date(new Date(o.paid_at).getTime() + DAY).toLocaleString()}`}>
      <Zap className="h-3 w-3" /> {left < 0 ? `Overdue by ${fmt(left)}` : `Rush · ${fmt(left)} left`}
    </span>
  );
};
